import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { ShoppingCart, X, ArrowLeft, Star, Percent } from "lucide-react";
import styles from "./BooksSection.module.css";

const ALL_BOOKS = [
  {
    id: 1,
    title: "كتاب مدرسي 1",
    subtitle: "العنوان الفرعي للكتاب 1",
    tag: "اللغة الإنجليزية",
    level: "الصف الثالث الثانوي",
    price: 108,
    oldPrice: 150,
    discount: "28%",
    image: "https://images.unsplash.com/photo-1544716278-ca5e3f4abd8c?w=500",
    desc: "هذا هو الوصف للكتاب 1 المميز والشامل لجميع أجزاء المنهج.",
    features: "يحتوي على امتحانات سابقة، ملخصات ذكية، وأسئلة متوقعة.",
  },
  {
    id: 2,
    title: "كتاب مدرسي 2",
    subtitle: "العنوان الفرعي للكتاب 2",
    tag: "اللغة الألمانية",
    level: "الصف الثالث الثانوي",
    price: 178,
    oldPrice: 206,
    discount: "14%",
    image: "/logo my store.jfif",
    desc: "الشرح الوافي لمنهج اللغة الألمانية بأسلوب مبسط.",
    features: "قاموس كلمات مدمج، تدريبات تفاعلية.",
  },
  {
    id: 3,
    title: "كتاب مدرسي 3",
    subtitle: "العنوان الفرعي للكتاب 3",
    tag: "اللغة الألمانية",
    level: "الصف الثاني الثانوي",
    price: 122,
    oldPrice: 165,
    discount: "26%",
    image: "https://images.unsplash.com/photo-1544716278-ca5e3f4abd8c?w=500",
    desc: "كتاب التدريبات المكثفة والشرح المبسط.",
    features: "امتحانات تفاعلية وشرح بالفيديو عبر باركود مدمج.",
  },
  {
    id: 4,
    title: "كتاب مدرسي 4",
    subtitle: "العنوان الفرعي للكتاب 4",
    tag: "اللغة التركية",
    level: "الصف الأول الثانوي",
    price: 144,
    oldPrice: 185,
    discount: "22%",
    image: "/logo my store.jfif",
    desc: "منهج اللغة التركية كاملاً مدعوماً بالصور التوضيحية.",
    features: "تمارين صوتية أونلاين، مراجعات نهائية متميزة.",
  },
];

const BooksSection = () => {
  const [showAll, setShowAll] = useState(false);
  const [selectedBook, setSelectedBook] = useState(null);

  const displayedBooks = showAll ? ALL_BOOKS : ALL_BOOKS.slice(0, 2);

  return (
    <section className={styles.sectionWrapper}>
      <div className="container">
        <div className={styles.sectionHeader}>
          <h2 className={styles.sectionTitle}>أقوى العروض</h2>
          <button
            className={styles.viewAllBtn}
            onClick={() => setShowAll(!showAll)}
          >
            {showAll ? "عرض أقل" : "عرض الكل"}
            <ArrowLeft
              size={16}
              className={showAll ? styles.rotateArrow : ""}
            />
          </button>
        </div>

        <motion.div layout className={styles.booksGrid}>
          <AnimatePresence>
            {displayedBooks.map((book) => (
              <motion.div
                layout
                key={book.id}
                className={styles.bookCard}
                initial={{ opacity: 0, scale: 0.9 }}
                animate={{ opacity: 1, scale: 1 }}
                exit={{ opacity: 0, scale: 0.9 }}
                transition={{ duration: 0.4 }}
                onClick={() => setSelectedBook(book)}
              >
                <div className={styles.imageContainer}>
                  <img
                    src={book.image}
                    alt={book.title}
                    className={styles.bookImg}
                  />
                  <button
                    className={styles.cartFloatingBtn}
                    onClick={(e) => {
                      e.stopPropagation();
                      alert("تم الإضافة للسلة");
                    }}
                  >
                    <ShoppingCart size={18} />
                  </button>
                </div>

                <div className={styles.cardContent}>
                  <span className={styles.bookTag}>{book.tag}</span>
                  <h3 className={styles.bookTitle}>{book.title}</h3>

                  <div className={styles.priceRow}>
                    <span className={styles.currentPrice}>
                      {book.price} ج.م
                    </span>
                    <span className={styles.oldPrice}>{book.oldPrice}</span>
                  </div>
                </div>
              </motion.div>
            ))}
          </AnimatePresence>
        </motion.div>

        <AnimatePresence>
          {selectedBook && (
            <>
              <motion.div
                className={styles.backdrop}
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
                onClick={() => setSelectedBook(null)}
              />

              <motion.div
                className={styles.detailsDrawer}
                initial={{ x: "100%" }}
                animate={{ x: 0 }}
                exit={{ x: "100%" }}
                transition={{ type: "spring", damping: 25, stiffness: 200 }}
              >
                <div className={styles.drawerHeader}>
                  <button
                    className={styles.closeBtn}
                    onClick={() => setSelectedBook(null)}
                  >
                    <X size={24} />
                  </button>
                  <span className={styles.drawerHeaderTitle}>
                    تفاصيل الكتاب
                  </span>
                </div>

                <div className={styles.drawerBody}>
                  <div className={styles.largeImageWrapper}>
                    <img
                      src={selectedBook.image}
                      alt={selectedBook.title}
                      className={styles.largeBookImg}
                    />
                  </div>

                  <h2 className={styles.drawerBookTitle}>
                    {selectedBook.title}
                  </h2>
                  <p className={styles.drawerSubtitle}>
                    {selectedBook.subtitle}
                  </p>

                  <div className={styles.badgeRow}>
                    <span className={`${styles.badge} ${styles.badgeOrange}`}>
                      {selectedBook.discount}-
                    </span>
                    <span className={`${styles.badge} ${styles.badgePrice}`}>
                      EGP {selectedBook.price}
                    </span>
                    <span className={styles.badgeOldPrice}>
                      EGP {selectedBook.oldPrice}
                    </span>
                  </div>

                  <div className={styles.tagsContainer}>
                    <span className={styles.pillTag}>{selectedBook.tag}</span>
                    <span
                      className={`${styles.pillTag} ${styles.pillTagSecondary}`}
                    >
                      {selectedBook.level}
                    </span>
                  </div>

                  <div className={styles.infoSection}>
                    <h3>الوصف</h3>
                    <p>{selectedBook.desc}</p>
                  </div>

                  <div className={styles.infoSection}>
                    <h3>المميزات</h3>
                    <p>{selectedBook.features}</p>
                  </div>
                </div>

                <div className={styles.drawerFooter}>
                  <button className={styles.addToCartBigBtn}>اضف للسلة</button>
                </div>
              </motion.div>
            </>
          )}
        </AnimatePresence>
      </div>
    </section>
  );
};

export default BooksSection;
